// Blog Images - Organized by post
export const blogImages = {
  // Blog Post Images
  'the-future-of-dental-technology': '/images/blog/The Future of Dental Technology/The Future of Dental Technology.jpg',
  'essential-dental-supplies-every': '/images/blog/Essential Dental Supplies Every/Essential Dental Supplies Every.jpg',
  'understanding-dental-materials': '/images/blog/Understanding Dental Materials/Understanding Dental Materials.jpg',
  'patient-safety-dental-practice': '/images/blog/Patient Safety in Dental Practice/Patient Safety in Dental Practice.jpg',
  
  // Default fallback
  'default': '/images/blog/default-blog.jpg'
};

// Helper function to get blog image
export const getBlogImage = (imageKey: string): string => {
  return blogImages[imageKey as keyof typeof blogImages] || blogImages.default;
};

// Blog image mapping for API responses
export const blogImageMap: Record<string, string> = {
  'The Future of Dental Technology': 'the-future-of-dental-technology',
  'Essential Dental Supplies Every': 'essential-dental-supplies-every',
  'Understanding Dental Materials': 'understanding-dental-materials',
  'Patient Safety in Dental Practice': 'patient-safety-dental-practice',
  
  // Slug-based mappings
  'future-dental-technology': 'the-future-of-dental-technology',
  'essential-dental-supplies-2024': 'essential-dental-supplies-every',
  'understanding-dental-materials': 'understanding-dental-materials',
  'patient-safety-dental-practice': 'patient-safety-dental-practice'
};
